export enum EDynEvents {
  CLICK_TO_ACT = 'onclicktoact',
  MODE_CHANGED = 'onmodechanged',
  PAGE_NAVIGATE = 'onpagenavigate',
  SEND_KB_ARTICLE = 'onsendkbarticle',
  SIZE_CHANGED = 'onsizechanged',
  // V2
  ON_SESSION_SWITCHED = 'onSessionSwitched',
  ON_SESSION_CLOSED = 'onSessionClosed',
}
